import React, { useEffect, useCallback, useState } from "react";
import axios from "axios";
import style from "css/realtime.module.css";
import { Empty, Modal, Table } from "antd";
import { useTranslation } from "react-i18next";
function RealtimeEndpointModal(props) {
  const { t } = useTranslation();
  const audioColums = [
    { title: "Audio", key: "index", dataIndex: "index", width: "auto" },
    { title: "In", key: "In", dataIndex: "In", width: "25%" },
    { title: "Out", key: "Out", dataIndex: "Out", width: "25%" },
  ];
  const videoColums = [
    { title: "Video", key: "index", dataIndex: "index", width: "auto" },
    { title: "In", key: "In", dataIndex: "In", width: "25%" },
    { title: "Out", key: "Out", dataIndex: "Out", width: "25%" },
  ];

  const [audioData, setAudioDatas] = useState([]);
  const [videoData, setVideoDatas] = useState([]);

  const getCallLegDetail = useCallback(() => {
    let url = "/active/callLegDetail";
    let param = {
      params: {
        PARTICIPANT: props.id
      },
    };

    axios.get(url, param).then((res) => {
      if (res.status === 200) {
        if (res.data.CALL_LEG_DETAIL_LIST !== null) {
          let audioInfo = res.data.CALL_LEG_DETAIL_LIST.audio;
          let videoInfo = res.data.CALL_LEG_DETAIL_LIST.video;
          let audio = [
            {
              key: "Packets transmitted",
              index: "Packets transmitted",
              In: audioInfo.txAudio_packets_sent,
              Out: audioInfo.rxAudio_packets_received,
            },
            {
              key: "Packets Lost",
              index: "Packets Lost",
              In: audioInfo.txAudio_packets_lost,
              Out: audioInfo.rxAudio_packets_lost,
            },
            {
              key: "Total percentage lost",
              index: "Total percentage lost",
              In: audioInfo.txAudio_packet_loss,
              Out: audioInfo.rxAudio_packet_loss,
            },
            {
              key: "Recent percentage lost",
              index: "Recent percentage lost",
              In: audioInfo.txAudio_windowed_packet_loss,
              Out: audioInfo.rxAudio_windowed_packet_loss,
            },
            {
              key: "Bitrate",
              index: "Bitrate",
              In: audioInfo.txAudio_bitrate,
              Out: audioInfo.rxAudio_bitrate,
            },
            {
              key: "Codec",
              index: "Codec",
              In: audioInfo.txAudio_codec,
              Out: audioInfo.rxAudio_codec,
            },
          ];
          let video = [
            {
              key: "Packets transmitted",
              index: "Packets transmitted",
              In: videoInfo.txVideo_packets_sent,
              Out: videoInfo.rxVideo_packets_received,
            },
            {
              key: "Packets Lost",
              index: "Packets Lost",
              In: videoInfo.txVideo_packets_lost,
              Out: videoInfo.rxVideo_packets_lost,
            },
            {
              key: "Total percentage lost",
              index: "Total percentage lost",
              In: videoInfo.txVideo_packet_loss,
              Out: videoInfo.rxVideo_packet_loss,
            },
            {
              key: "Recent percentage lost",
              index: "Recent percentage lost",
              In: videoInfo.txVideo_windowed_packet_loss,
              Out: videoInfo.rxVideo_windowed_packet_loss,
            },
            {
              key: "Bitrate",
              index: "Bitrate",
              In: videoInfo.txVideo_bitrate,
              Out: videoInfo.rxVideo_bitrate,
            },
            {
              key: "Codec",
              index: "Codec",
              In: videoInfo.txVideo_codec,
              Out: videoInfo.rxVideo_codec,
            },
            {
              key: "Resolution",
              index: "Resolution",
              In: videoInfo.txVideo_resolution,
              Out: videoInfo.rxVideo_resolution,
            },
          ];
          setAudioDatas(audio);
          setVideoDatas(video);
        }
      }
    });
  }, [props.id]);

  useEffect(() => {
    if (props.open && props.id !== "") {
      getCallLegDetail();
    }
  }, [getCallLegDetail, props]);

  return (
    <Modal
      centered
      title="단말 상세정보"
      open={props.open}
      onCancel={props.close}
      footer={null}
    >
      <div className={style.endpointModal}>
        <Table
          rowKey="uid"
          size="small"
          columns={audioColums}
          dataSource={audioData}
          pagination={false}
          locale={{ emptyText: <Empty description={t("MESSAGE.NO_DATA")} /> }}
        />
        <Table
          rowKey="uid"
          size="small"
          columns={videoColums}
          dataSource={videoData}
          pagination={false}
          locale={{ emptyText: <Empty description={t("MESSAGE.NO_DATA")} /> }}
        />
      </div>
    </Modal>
  );
}

export default RealtimeEndpointModal;
